<div class="row p-2 mb-4">
    <div class="col-12 col-md-6 text-start">
        <div class="">
            <input type="text" name="" class="form-control" placeholder="Rechercher" id="">
        </div>
    </div>
    <div class="col-12 col-md-6 text-end">
        <app-header></app-header>
    </div>
</div>

<div class="row mb-5">
    <div class="col-12 col-md-8">
        <div class="border-danger rounded ag-bg-red text-white p-3">
            <p class="h2">Bienvenue sur votre espace éducatif {{user?.professor?.lastname}} {{user?.professor?.firstname}}, nous vous souhaitons une belle journée de travail sur votre espace éducatif </p>
            <p class="d-flex justify-content-between">
                <span><i class="fa fa-envelope" aria-hidden="true"></i> Email: {{user?.email}}</span>
                <span> <i class="fa fa-phone" aria-hidden="true"></i>  phone:{{user?.professor?.phone}}</span>
            </p>
        </div>
      <div class="row">
        <div class="col-12 col-md-4 p-3">
            <div class="d-flex justify-content-between mb-3">
                <span class="text-muted">Total Classe</span>
                <span class="text-success"><i class="fa fa-long-arrow-up" aria-hidden="true"></i> 43%</span>
            </div>
            <h6><b>147</b></h6>
        </div>
        <div class="col-12 col-md-4 p-3">
            <div class="d-flex justify-content-between mb-3">
                <span class="text-muted">Total Classe</span>
                <span class="text-success"><i class="fa fa-long-arrow-down" aria-hidden="true"></i> 43%</span>
            </div>
            <h6><b>147</b></h6>
        </div>
        <div class="col-12 col-md-4 p-3">
            <div class="d-flex justify-content-between mb-3">
                <span class="text-muted">Total Classe</span>
                <span class="text-success"><i class="fa fa-long-arrow-down" aria-hidden="true"></i> 43%</span>
            </div>
            <h6><b>147</b></h6>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-4">
        <mat-card class="demo-inline-calendar-card">
            <mat-calendar [(selected)]="selected"></mat-calendar>
          </mat-card>
    </div>
</div>

<div class="row mb-5">
    <div class="col-12 col-md-4">
        <h6><b>Présence des étudiants</b></h6>
        <canvas baseChart
        [type]="'pie'"
        [datasets]="pieChartDatasets"
        [labels]="pieChartLabels"
        [options]="pieChartOptions"
        [plugins]="pieChartPlugins"
        [legend]="pieChartLegend">
      </canvas>
    </div>
    <div class="col-12 col-md-4">
        <h6><b>Performance des étudiants</b></h6>
        <canvas baseChart
        [data]="barChartData"
        [options]="barChartOptions"
        [plugins]="barChartPlugins"
        [legend]="barChartLegend"
        [type]="'bar'">
</canvas>
    </div>
    <div class="col-12 col-md-4">
    <h6><b>Agenda</b></h6>
    <ul class="list-unstyled">
        <li>
            <div class="border-top border-success p-1 mb-2">
            <div class="d-flex justify-content-between"> <span>Réunion</span> <span>12:12</span> </div>
            <p><b>Parler des compétences scolaire</b></p>
            </div>
        </li>
    </ul>
    </div>
</div>

<div class="row">
    <div class="col-12 col-md-4">
        <h6><b>Tâche à faire</b></h6>
        <div class="form-group">
            <input type="text" class="mb-3 w-100" name="" placeholder="Rechercher" id="">

            <ul class="list-unstyled">
                <li>
                    <div class="d-flex">
                        <div class="form-group p-3">
                            <input type="checkbox" name="" id="">
                        </div>
                        <div class="w-75">
                            <h6>Essais des élèves</h6>
                            <p>29 Janv. 2024</p>
                        </div>
                        <div class="w-25">
                            <ul class="list-unstyled list-inline">
                                <li class="list-inline-item d-flex justify-content-around ">
                                    <i class="fa fa-edit" aria-hidden="true"></i>
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                </li>
                            </ul>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

    </div>
    <div class="col-12 col-md-8">
        <canvas baseChart class="w-100" height="400"
        [type]="'line'"
        [data]="lineChartData"
        [options]="lineChartOptions"
        [legend]="lineChartLegend">
      </canvas>
    </div>
</div>

